import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import { TableContentCollectionSummaryReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { CollectionSummaryReportSchemaObject } from "../CollectionSummaryReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import _ from "lodash";
import '../Pages/tableFooter.css';
import xlsx from "json-as-xlsx";

const screenCode = "COLLECTIONSUMMARYREPORT";

export function CollectionSummaryReport(props) {
  const componentRef = useRef();

  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [isTableHide, setIsTableHide] = useState(true);


  const [collectionSummaryReport, setCollectionSummaryReport] = useState({
    groupID: "0",
    factoryID: "0",
    collectionPointID: "0",
    date: "",
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    group: "0",
    factory: "0",
    collectionPointID: "0",
    date: "",
  });

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const schema = Joi.object(CollectionSummaryReportSchemaObject).options({
    allowUnknown: true,
  });
  const [contentRowNames, setContentRowNames] = useState([]);
  const [headerNames, setHeaderNames] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [fullTotalRow, setFullTotalRow] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [grossTotal, setGrossTotal] = useState([]);
  const [netTotal, setNetTotal] = useState([]);
  const [csvTotalRow, setCsvTotalRow] = useState([]);
  
  const initialContentRowNames = ["collectionPointName", "grossAmount","netAmount"];
  const initialHeaderNames = ["Name", "Registration Number"];
  const initalCsvHeaders = [
    { label: "Collection Point", value: "collectionPointName" },
    { label: "Gross Amount", value: "grossAmount" },
    { label: "Net Amount", value: "netAmount" },

  ];

  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
  }, [collectionSummaryReport.groupID]);

  useEffect(() => {
    trackPromise(getCollectionPointsForDropDown());
  }, [collectionSummaryReport.factoryID]);

  useEffect(() => {
    createDataTable();
  }, [reportData]);


  function handleChange(e) {
    e.preventDefault();

    const target = e.target;
    const value = target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(target, CollectionSummaryReportSchemaObject);
    errorMessage ? error[target.name] = errorMessage : delete error[target.name];

    setCollectionSummaryReport({
        ...collectionSummaryReport,
        [e.target.name]: value
    })
}

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWCOLLECTIONSUMMARYREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setCollectionSummaryReport({
      ...collectionSummaryReport,
      groupID: token.groupID,
      factoryID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getFactoriesForDropdown() {
    const data = await services.getFactoriesByGroupID(
        collectionSummaryReport.groupID
    );
    setFactories(data);
  }

  async function getCollectionPointsForDropDown() {
    const collectionPoint =
      await services.getCollectionPointsByOperationentityGroupID(
        collectionSummaryReport.groupID,
        collectionSummaryReport.factoryID
      );
    setCollectionPoint(collectionPoint);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    e.preventDefault();
    setIsTableHide(true);

    const errorMessages = validate(schema, collectionSummaryReport);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    getSelectedDropdownValuesForReport(collectionSummaryReport);

    const result = await services.getCollectionSummaryReportData(collectionSummaryReport.factoryID,collectionSummaryReport.collectionPointID,collectionSummaryReport.date);
    calTotalVloume(result)

    var totRecord = {
      collectionPointName: "Total",
    };

    result.forEach((x, i) => {
      for (const item in x) {
          if ((item) !== "collectionPointName") {
              totRecord[item] = (totRecord[item] === undefined ? 0 : parseFloat(totRecord[item])) + parseFloat(x[item]);
          }
      }
    });

  setCsvTotalRow(totRecord);

    if (result.length > 0) {
        setIsTableHide(false);
        setReportData(result);
        createDataTable();
      }
  }

  async function calTotalVloume(data) {
    if (data != null || data != undefined) {
        const grossTotal = data.reduce((previousScore, currentScore, index) => previousScore + currentScore.grossAmount, 0);
        const netTotal = data.reduce((previousScore, currentScore, index) => previousScore + currentScore.netAmount, 0);
        setGrossTotal(grossTotal);
        setNetTotal(netTotal);
    }
}

  function destroyDataTable() {
    $("#reportTable").DataTable().destroy();
  }

  function createDataTable() {
    $("#reportTable").DataTable({
      scrollX: true
    });
  }

  function createFile() {
    var settings = {
      sheetName: "Collection Summary Report",
      fileName: "CollectionSummaryReport",
      writeOptions: {},
    };

    var copyOfCsv = _.cloneDeep(reportData)
    copyOfCsv.push(csvTotalRow)

    copyOfCsv.push({}, {
      collectionPointName: "Group: " + selectedSearchValues.group,
      grossAmount: "Factory: " + selectedSearchValues.factory,
      netAmount: "Current Date" + new Date().toLocaleString()
  });
  var copyOfCsv1 = _.cloneDeep(copyOfCsv)
    copyOfCsv1.push({
      collectionPointName: "User: " + tokenService.getUserNameFromToken(),
      grossAmount: "Date: " + selectedSearchValues.date
  });

    xlsx(initalCsvHeaders, copyOfCsv1, settings, true);
  }

  function onCancelClick() {
    clearState();
  }

  function clearState() {
    setCollectionSummaryReport({
      ...collectionSummaryReport,
      routeID: "0",
      date: "",
    });
    setErrors("");
    clearTabeData();
  }

  function clearTabeData() {
    setIsTableHide(true);
    destroyDataTable();
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      factory: factories[searchForm.factoryID],
      collectionPointID: collectionPoint[searchForm.collectionPointID],
      date: searchForm.date,
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Collection Summary Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={collectionSummaryReport.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="factoryID">
                      Factory *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="factoryID"
                      id="factoryID"
                      name="factoryID"
                      value={collectionSummaryReport.factoryID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="0">--Select Factory--</MenuItem>
                      {generateDropDownMenu(factories)}
                    </Select>
                    {errors["factoryID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["factoryID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="collectionPointID *">
                      Collection point
                    </InputLabel>
                    <Select
                      fullWidth
                      id="collectionPointID"
                      name="collectionPointID"
                      value={collectionSummaryReport.collectionPointID}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="0">--Select Collection point--</MenuItem>
                      {generateDropDownMenu(collectionPoint)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md">
                    <InputLabel shrink id="date">
                      Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="date"
                      name="date"
                      type="date"
                      onChange={(e) => handleChange(e)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["date"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["date"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    disabled={validate(schema, collectionSummaryReport)}
                    type="button"
                    className="btn btn-primary"
                    value="Generate"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />

                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>

              {isTableHide ? null : (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive row-top-gap">
                        <table
                          id="reportTable"
                          className="display dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th rowSpan="2">Welfare Society</th>
                              <th rowSpan="2">Gross Amount</th>
                              <th rowSpan="2">Net Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            <TableContentCollectionSummaryReport
                              data={reportData}
                              contentRowNames={initialContentRowNames}
                              hasEdit={false}
                            />
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan="1">Total</th>
                              <th style={{ textAlign: "right" }}>{grossTotal.toFixed(2)}</th>
                              <th style={{ textAlign: "right" }}>{netTotal.toFixed(2)}</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="pt-2">
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="Excel"
                      onClick={createFile}
                    />

                    <ReactToPrint
                      documentTitle={"Collection Summary Report"}
                      trigger={() => (
                        <input
                          type="submit"
                          className="btn btn-primary pull-right ml-2"
                          value="PDF"
                        />
                      )}
                      content={() => componentRef.current}
                    />
                  </div>
                  <div hidden={true}>
                    <CreatePdf
                      ref={componentRef}
                      data={reportData}
                      fullTotalRow={fullTotalRow}
                      rowNames={initialContentRowNames}
                      searchData={selectedSearchValues}
                      headerNames={headerNames}
                      grossTotal={grossTotal}
                      netTotal={netTotal}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
